import { InputForm, SubmitButton, Error, SelectForm } from "components";
import {
  CreateCouponInput,
  CouponError,
  CouponDetailsProps,
} from "../../store/actionType";
import CreatedCouponCard from "../CreatedCouponCard";
import { useEffect } from "react";
import { fetchPackages } from "modules/membership_plan/commercial_membership_plan/packages/store/action";
import { fetchMembershipDurationByPackageId } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/action";
import { connect } from "react-redux";
import { PackageProps } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { MembershipDurationsProps } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/actionType";
import { CouponGenerationType } from "props/enum";
import { CommercialUserProps } from "modules/user_management/commercial_user/user/state/actionType";

interface FormProps {
  formData: CreateCouponInput;
  formError: CouponError;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
  loading: boolean;
  couponData: CouponDetailsProps[];
  onReceiverSelect: (user: CommercialUserProps) => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & FormProps;
const CouponForm: React.FC<Props> = ({
  onFetchMembershipDuration,
  fetchMembershipDurationByPackageId,
  onFetchPackages,
  fetchPackages,
  handleChange,
  handleSubmit,
  formError,
  formData,
  loading,
  couponData,
}) => {
  useEffect(() => {
    onFetchPackages();
    if (formData.package_id) {
      onFetchMembershipDuration(formData.package_id);
    }
  }, [formData.package_id, onFetchMembershipDuration, onFetchPackages]);
  return (
    <>
      <div className="flex items-center gap-4 m-4">
        <form className="w-full">
          <h2 className="text-lg font-bold my-4">Create Coupon</h2>
          <div className="w-4/5">
            <div>
              <SelectForm
                label="Select Package"
                id="package_id"
                name="package_id"
                value={formData.package_id}
                option={fetchPackages?.packages?.map((pkg: PackageProps) => (
                  <option key={pkg.id.toString()} value={pkg.id.toString()}>
                    {pkg.name}
                  </option>
                ))}
                onChange={(e) => {
                  handleChange(e);
                  onFetchMembershipDuration(e.target.value);
                }}
              />
            </div>

            <SelectForm
              label="Select Membership Duration"
              id="membershipDurationID"
              name="membershipDurationID"
              value={formData.membershipDurationID}
              option={
                formData.package_id
                  ? fetchMembershipDurationByPackageId?.membershipDuration?.map(
                      (item: MembershipDurationsProps) => (
                        <option
                          key={item.id.toString()}
                          value={item.id.toString()}
                        >
                          {item.duration_type}
                        </option>
                      )
                    )
                  : []
              }
              onChange={handleChange}
            />
            {formError.membershipDurationID && (
              <Error>{formError.membershipDurationID}</Error>
            )}
            <div>
              <SelectForm
                label="Generation Type"
                type="text"
                id="generationType"
                name="generationType"
                value={formData?.generationType}
                option={Object.values(CouponGenerationType).map((value) => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
                onChange={handleChange}
              />
              {formError?.generationType && (
                <Error>{formError?.generationType}</Error>
              )}
            </div>
            {formData.generationType === CouponGenerationType.admin && (
              <InputForm
                type="text"
                label="Receiver Detail"
                id="receiverDetail"
                name="receiverDetail"
                value={formData.receiverDetail}
                onChange={handleChange}
              />
            )}
            {formData.generationType === CouponGenerationType.printed && (
              <div key="count">
                <InputForm
                  type="number"
                  label="Number of Generate"
                  id="count"
                  name="count"
                  value={formData.count}
                  onChange={handleChange}
                />
                {formError.count && <Error>{formError.count}</Error>}
              </div>
            )}
          </div>
          <div className="py-4">
            <SubmitButton onClick={handleSubmit} loading={loading}>
              Generate
            </SubmitButton>
          </div>
        </form>
        <CreatedCouponCard couponData={couponData} />
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  fetchPackages: state.packages?.fetchPackagesState,
  fetchMembershipDurationByPackageId:
    state.membershipDuration?.fetchmembershipDurationState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchPackages: () => dispatch(fetchPackages()),
  onFetchMembershipDuration: (package_id: string) =>
    dispatch(fetchMembershipDurationByPackageId(package_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponForm);
